/**
 * Gets the chat history state from the Redux store
 */
export function getChatHistoryState(state) {
    return state['features/chat_history'];
}
/**
 * Gets whether the chat history panel is visible
 */
export function isChatHistoryVisible(state) {
    return getChatHistoryState(state).visible;
}
/**
 * Gets the currently selected conversation ID
 */
export function getSelectedConversationId(state) {
    return getChatHistoryState(state).selectedConversationId;
}
/**
 * Gets the list of conversations
 */
export function getConversationsList(state) {
    return getChatHistoryState(state).conversations;
}
/**
 * Gets the chat messages
 */
export function getChatMessages(state) {
    return getChatHistoryState(state).messages;
}
/**
 * Gets the accumulated final STT transcript lines.
 */
export function getTranscripts(state) {
    return getChatHistoryState(state).transcripts;
}
/**
 * Gets the current in-progress (interim) STT lines as an array, oldest first.
 */
export function getInterimTranscripts(state) {
    return Object.values(getChatHistoryState(state).interims)
        .sort((a, b) => a.ts - b.ts);
}
/**
 * Gets the current streaming AI-response lines as an array, oldest first.
 */
export function getAiInterims(state) {
    return Object.values(getChatHistoryState(state).aiInterims)
        .sort((a, b) => a.ts - b.ts);
}
/**
 * Formats the action type for display
 */
export function formatActionType(action) {
    switch (action) {
        case 'text':
            return 'テキスト';
        case 'nod':
            return '相槌';
        case 'store':
            return '保留';
        case 'other':
            return 'その他';
        default:
            return action;
    }
}
/**
 * Gets the color for the action type
 */
export function getActionColor(action) {
    switch (action) {
        case 'text':
            return '#0066cc'; // Blue
        case 'nod':
            return '#28a745'; // Green
        case 'store':
            return '#ffc107'; // Yellow
        case 'other':
            return '#6c757d'; // Gray
        default:
            return '#000000';
    }
}
/**
 * Formats timestamp for display
 */
export function formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
}
/**
 * Returns whether the chat history button is enabled.
 *
 * @param {IReduxState} state - The Redux state.
 * @returns {boolean}
 */
export function isChatHistoryButtonEnabled(state) {
    // Always enabled for now - you can add conditions here later
    return true;
}
